export default "__VITE_ASSET__D4WjFW8___"